export default "__VITE_ASSET__CDJMq0a1__"